var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoTipBox"},[_c('img',{attrs:{"src":require("../views/img/videoTip1.png"),"alt":""}}),_c('div',[_vm._v("新手视频演示，图片编辑一分钟学会，累计"+_vm._s(_vm.docnum)+"人已观看--------- "),_c('span',{on:{"click":function($event){return _vm.closeTipBox()}}},[_vm._v("关闭提醒")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }